import { z } from 'zod'

import { PrintJobStatus, PrintJobType } from '../constants/printJob'
import { dbEntitySchema, listQueryZodFields } from './system'

export const printJobSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  printer: z.string(),
  type: z.nativeEnum(PrintJobType),
  sourceId: z.string().optional().nullable(),
  idempotencyKey: z.string().optional().nullable(),
  payload: z.record(z.unknown()).default({}),
  renderedXml: z.string().optional().nullable(),
  status: z.nativeEnum(PrintJobStatus),
  attempts: z.number().int().min(0).default(0),
  epsonJobId: z.string().optional().nullable(),
  dispatchedAt: z.date().optional().nullable(),
  printedAt: z.date().optional().nullable(),
  lastError: z.string().optional().nullable(),
  dispatchLeaseExpiresAt: z.date().optional().nullable(),
})

export const printJobCreateTestArgsSchema = z.object({
  venueId: z.string(),
  printerId: z.string(),
})

export const printJobListQuerySchema = z.object({
  ...listQueryZodFields,
  venueId: z.string(),
  printerId: z.string().optional().nullable(),
  status: z.nativeEnum(PrintJobStatus).optional().nullable(),
  type: z.nativeEnum(PrintJobType).optional().nullable(),
})

export const printJobListResponseSchema = z.object({
  data: z.array(printJobSchema),
})
